"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootExtendNode = void 0;
const react_1 = __importStar(require("react"));
const typestyle_1 = require("typestyle");
const PaintNode_1 = require("../PaintNode");
const Colors_1 = require("../../../Colors");
const index_1 = require("../components/index");
const index_2 = require("../ContextMenu/index");
const index_3 = require("../../icons/index");
const NodeCaption = typestyle_1.style({
    flexBasis: '100%',
    margin: `15px 15px`,
    display: 'flex',
    borderBottom: `1px solid ${Colors_1.Colors.orange[0]}22`,
    paddingBottom: 5,
    alignItems: 'center',
});
const CaptionTitle = typestyle_1.style({
    marginRight: 10,
    color: Colors_1.Colors.orange[0],
});
const NodeContainer = typestyle_1.style({
    padding: 10,
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    height: '100%',
});
const ExtendButton = typestyle_1.style({
    position: 'relative',
    borderColor: Colors_1.Colors.orange[0],
    borderWidth: 1,
    borderStyle: 'solid',
    padding: `5px 10px`,
    borderRadius: 4,
    width: 200,
    cursor: 'pointer',
    margin: 15,
    display: 'flex',
    alignItems: 'center',
    transition: `border-color 0.25s ease-in-out`,
});
const ExtendButtonTitle = typestyle_1.style({
    padding: `0 5px`,
    fontSize: 12,
    color: Colors_1.Colors.grey[0],
});
const ExtendMenuContainer = typestyle_1.style({
    position: 'absolute',
    top: 30,
    right: -70,
});
const PlusButton = typestyle_1.style({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    color: Colors_1.Colors.grey[0],
    border: `1px solid ${Colors_1.Colors.grey[0]}11`,
    width: 20,
    height: 20,
    borderRadius: 10,
});
exports.RootExtendNode = ({ node, libraryNode }) => {
    var _a, _b;
    const thisNode = react_1.useRef(null);
    const [filterNodes, setFilterNodes] = react_1.useState('');
    const [menuOpen, setMenuOpen] = react_1.useState(false);
    return (react_1.default.createElement("div", { className: `${NodeContainer}`, ref: thisNode },
        react_1.default.createElement("div", { className: `${NodeCaption}` },
            react_1.default.createElement("span", { className: CaptionTitle }, "extend"),
            react_1.default.createElement(index_1.MenuSearch, { autoFocus: false, onClear: () => {
                    setFilterNodes('');
                }, value: filterNodes, onChange: setFilterNodes })),
        react_1.default.createElement("div", { className: ExtendButton, onClick: () => {
                setMenuOpen(true);
            } },
            react_1.default.createElement("span", { className: ExtendButtonTitle }, "Extend node"),
            react_1.default.createElement("span", { className: `${PlusButton}` },
                react_1.default.createElement(index_3.Plus, { width: 10, height: 10 })),
            menuOpen && (react_1.default.createElement("div", { className: ExtendMenuContainer },
                react_1.default.createElement(index_2.ExtendNodeMenu, { hideMenu: () => {
                        setMenuOpen(false);
                    } })))), (_a = node.args) === null || _a === void 0 ? void 0 :
        _a.map((a, i) => {
            return (react_1.default.createElement(PaintNode_1.PaintNode, { isMatchedToSearch: a.name.toLowerCase().includes(filterNodes.toLowerCase()), key: a.name, node: a }));
        }), (_b = libraryNode === null || libraryNode === void 0 ? void 0 : libraryNode.args) === null || _b === void 0 ? void 0 :
        _b.map((a) => {
            return (react_1.default.createElement(PaintNode_1.PaintNode, { isMatchedToSearch: a.name.toLowerCase().includes(filterNodes.toLowerCase()), isLibrary: true, key: a.name, node: a }));
        })));
};
